// Единая шина событий в соответствии с архитектурой проекта
// docs/architecture.md -> 1. Core -> 1.2 EventBus

export interface IEvent {
  type: string;
  data?: any;
}

export interface IEventListener {
  (event: IEvent): void;
}

export class EventBus {
  private static instance: EventBus;
  private events: Map<string, IEventListener[]> = new Map();

  private constructor() { }

  public static getInstance(): EventBus {
    if (!EventBus.instance) {
      EventBus.instance = new EventBus();
    }
    return EventBus.instance;
  }

  public subscribe(type: string, listener: IEventListener): void {
    if (!this.events.has(type)) {
      this.events.set(type, []);
    }
    this.events.get(type)!.push(listener);
  }

  public on(type: string, listener: IEventListener): void {
    this.subscribe(type, listener);
  }

  public unsubscribe(type: string, listener: IEventListener): void {
    if (this.events.has(type)) {
      const listeners = this.events.get(type)!;
      const index = listeners.indexOf(listener);
      if (index > -1) {
        listeners.splice(index, 1);
      }
    }
  }

  public off(type: string, listener: IEventListener): void {
    this.unsubscribe(type, listener);
  }

  public publish(event: IEvent): void {
    const listeners = this.events.get(event.type);
    if (listeners) {
      listeners.forEach(listener => listener(event));
    }
  }
}

// Примеры событий из архитектуры
export const EVENT_TYPES = {
  PLAYER_LEVEL_UP: 'player:levelUp',
  ENEMY_HIT: 'enemy:hit',
  ENEMY_KILLED: 'enemy:killed',
  BOSS_SPAWNED: 'boss:spawned',
  BOSS_KILLED: 'boss:killed',
  WEAPON_FIRED: 'weapon:fired',
  LOOT_COLLECTED: 'loot:collected',
  XP_GAINED: 'xp:gained',
  LEVEL_UP: 'level:up',
  GAME_PAUSE: 'game:pause',
  GAME_RESUME: 'game:resume',
  UPGRADE_SELECTED: 'upgrade:selected',
  PLAYER_HEAL: 'player:heal',
  PLAYER_GOLD: 'player:gold',
  BIOME_CHANGED: 'biome:changed'
};
